var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAcademyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 8,
    fill: "#E6F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 24V12H11V24H9V27C9 27.7956 9.31607 28.5587 9.87868 29.1213C10.4413 29.6839 11.2044 30 12 30H30C30.7956 30 31.5587 29.6839 32.1213 29.1213C32.6839 28.5587 33 27.7956 33 27V24H31ZM13 14H29V24H23.921L23.074 25H18.925L18.079 24H13V14ZM31 27C31 27.2652 30.8946 27.5196 30.7071 27.7071C30.5196 27.8946 30.2652 28 30 28H12C11.7348 28 11.4804 27.8946 11.2929 27.7071C11.1054 27.5196 11 27.2652 11 27V26H17.151L18 27H24L24.847 26H31V27Z",
    fill: "#0073FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademyIcon);
export default __webpack_public_path__ + "static/media/academy-icon.0f14ac3e02a252dab39cfe7f2848e09c.svg";
export { ForwardRef as ReactComponent };